import { useState, useCallback } from 'react';
import MultiplasService from './MultiplasService';
import { getMultiplasPrompt } from './multiplasPrompts';
import { parseMultiplasPrediction } from './multiplasParser';

const useMultiplasPrediction = () => {
  const [loading, setLoading] = useState(false);
  const [prediction, setPrediction] = useState(null);
  const [error, setError] = useState(null);
  const [streamingText, setStreamingText] = useState('');

  const getBestBets = useCallback(async (gameData, sport, userId) => {
    setLoading(true);
    setError(null);
    setPrediction(null);
    setStreamingText('');

    try {
      const prompt = getMultiplasPrompt(gameData, sport);

      MultiplasService.setStreamCallback((chunk) => {
        setStreamingText(prev => prev + chunk);
      });

      const response = await MultiplasService.getBestBets(gameData, sport, prompt, userId);

      const parsedPrediction = parseMultiplasPrediction(response, sport);
      setPrediction(parsedPrediction);

      return parsedPrediction;
    } catch (err) {
      console.error('Error getting best bets:', err);
      setError(err.message || 'Failed to get best bets');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setLoading(false);
    setPrediction(null);
    setError(null);
    setStreamingText('');
  }, []);

  return {
    loading,
    prediction,
    error,
    streamingText,
    getBestBets,
    reset,
  };
};

export default useMultiplasPrediction;